// removed by extract-text-webpack-plugin
module.exports = {"goTop":"goTop_goTop_1Dwc-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/common/goTop/goTop.scss
// module id = 1538
// module chunks = 0